module.exports = __webpack_public_path__ + "static/breizhcamp-045d1b75daad7643d20e2abb8c413f4d.png";